// extracted by mini-css-extract-plugin
export default {"Message":"_5dUpW","isTopPlacement":"oXlBG","success":"KSogt","error":"iRarb","container":"lqWj2","iconWrapper":"FZ9vu","content":"yv-tv","skeleton-progress":"kDXwc"};